module.exports = __webpack_public_path__ + "img/prospects_bg.8986e4df.png";